import { ExternalCalendarEvent, ID } from '@griply/types';

// The optimistic-delete transform for one cached events window. A window still in flight
// holds `undefined` and must stay that way — seeding it with `[]` would present an
// unresolved query as an empty day.
export const removeExternalEventFromWindow = (
  events: ExternalCalendarEvent[] | undefined,
  eventId: ID,
): ExternalCalendarEvent[] | undefined =>
  events?.filter(({ id }) => id !== eventId);
